module.exports = __webpack_public_path__ + "img/half-rhombus-1.6fde402f.svg";